import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const resource = '/staff'
const logoutResource = '/staff/logout'

export default {
  staffLogin(payload) {
    return OperationsRepository.post(`${resource}/login`, payload)
  },
  getPermissions() {
    return OperationsRepository.get('/admin/staff/get-current-permissions')
  },
  getCurrentUser() {
    return OperationsRepository.get('/admin/staff/get-current')
  },
  staffLogout() {
    return OperationsRepository.get(`${logoutResource}`)
  },
  changeUserPassword(payload) {
    return Repository.post(`${resource}/ChangePassword`, payload)
  },
  forgotPasswordEmailSubmit(payload) {
    return Repository.post(`${resource}/forgot-password`, payload)
  },
  forgotPasswordTokenVerify(token) {
    return Repository.get(`${resource}/forgot-password/${token}`)
  },
  forgotPasswordReset(payload) {
    return Repository.post(`${resource}/reset-password`, payload)
  },
}
